import React, { JSX, ReactNode, createContext, useState } from 'react';

export interface ThemeState {
  theme: string;
}
interface ThemeContextProps {
  themeState: ThemeState;
  setThemeState: React.Dispatch<React.SetStateAction<ThemeState>>;
}
interface ThemeProviderProps<T extends ReactNode> {
  children: T;
}

const ThemeContext = createContext<ThemeContextProps | undefined>(undefined);

export const ThemeProvider = <T extends ReactNode>({
  children,
}: ThemeProviderProps<T>): JSX.Element => {
  const [themeState, setThemeState] = useState<ThemeState>({
    theme: '',
  });

  return (
    <ThemeContext value={{ themeState, setThemeState }}>
      {children}
    </ThemeContext>
  );
};

export default ThemeContext;
